<template>
  <div>
    <v-dialog :value="dialog" :max-width="width" persistent>
      <v-card>
        <v-card-text class="pt-5 pb-0" outlined tile>
          <Title class="pb-1" text-start :font-weight="600" :font-size="18" title="Помощь"/>

          <v-row>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="message.fullName"
                placeholder="Введите данные"
                outlined
                rounded
                dense
              >
                <template #label>
                  <span class="required">Фамилия Имя Отчество</span>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="message.email"
                placeholder="Введите данные"
                outlined
                rounded
                dense
              >
                <template #label>
                  <span class="required">Электронная почта</span>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" class="py-0">
              <v-lazy>
                <v-textarea
                  v-model="message.questionBody"
                  placeholder="Введите данные"
                  outlined
                  rounded
                  dense
                  auto-grow
                  rows="1"
                >
                  <template #label>
                    <span class="required">Опишите суть проблемы</span>
                  </template>
                </v-textarea>
              </v-lazy>
            </v-col>

            <v-col cols="12" class="pb-0">
              <FileInput
                :limit="1"
                @set-files="addFile"
              />
            </v-col>

          </v-row>
        </v-card-text>

        <v-card-actions class="px-6 mt-2">
          <v-spacer></v-spacer>
          <v-btn text color="lightGrey" @click="closeDialog">{{'Отмена'}}</v-btn>
          <v-btn
            color="primary"
            :loading="loading"
            :disabled="$v.$invalid || filesData.invalid"
            text
            @click="confirm"
          >
            {{'Принять'}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Title from '@/components/ui/Title'
import FileInput from "@/components/ui/FileInput";
import {messageApi} from "@/api";
import {MessageForFormData} from "@/models/MessageForFormData";
import {required} from "vuelidate/lib/validators";

export default {
  name: 'HelpDialog',

  components: {
    Title,
    FileInput
  },

  props: {
    dialog: Boolean,
    title: String,
    width: {
      type: [Number, String],
      default: 600
    }
  },

  data: () => ({
    message: new MessageForFormData(),
    filesData: {invalid: false, files: []},
    loading: false,
  }),

  validations() {
    return {
      message: {
        fullName: {required},
        email: {required},
        questionBody: {required}
      }
    }
  },

  computed: {
  },

  methods: {
    addFile(filesData) {
      this.filesData = filesData
    },

    async confirm() {
      try {
        this.loading = true
        const data = await messageApi.helpMessage(this.message.getForAPI(), this.filesData.files[0])
        this.$emit('closeHelpDialog')
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.loading = false
      }
    },

    closeDialog() {
      this.$emit('closeHelpDialog')
      this.resetFunc()
    },

    resetFunc() {
      this.message = new MessageForFormData()
      this.filesData = {invalid: false, files: []}
    }
  }
}
</script>

<style scoped>

</style>
